import React, { useState } from 'react';
import "./UserProfile.css";
import LikeDislikeComponent from './LikeDislikeComponentUserProfile.js';
import StarComponent from './StarComponent';

const ReviewComponent = ({logo, userName, timePublished, reviewRating, comment, likes, dislikes}) => {
//   const [review, setReview] = useState('');

  return (
    <div className='horizontal-flex' style={{paddingTop: '15px'}}>
      <div className='col-container'>
        
        
        
      </div>
      <div className='vertical-flex' style={{ width: '56.5%', marginLeft:"9.2%", marginTop:"13%"}}>
        <div className='horizontal-flex' style={{ width: '100%', justifyContent:'space-between'}}>
          <span className='col-container'>
            <div className=''>
              {userName}
            </div>

            <div className='published-date'>
              {timePublished}
            </div>
          </span>
          <div className='col-container'>
            <StarComponent
              rating={reviewRating}
            />
          </div>
        </div>
        <span className="review-text">
          {comment}
        </span>
        <LikeDislikeComponent 
          likeCount={likes.length}
        />
      </div>
    </div>
  );
};

export default ReviewComponent;
